import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import "./course-offering-display.css";

const CourseOfferingDisplay = ({ courseDetails }) => {
  const { title = "", leftCol = [], rightCol = [], fullCol = [] } = courseDetails || {};

  const renderDetails = (details) =>
    details.map((detail, index) => (
      <React.Fragment key={index}>
        <div className="offered-course-title">{detail.title} </div>
        <div className="offered-course-data">{detail.info}</div>
      </React.Fragment>
    ));

  return (
    <Container fluid className="course-offering">
      <Row>
        <Col className="mb-3">
          <h3 className="course-offering-header font-weight-bold">{title}</h3>
        </Col>
      </Row>
      <Row>
        <Col md={5}>
          <div className="d-flex flex-wrap">{renderDetails(leftCol)}</div>
        </Col>
        <Col md={{ span: 5, offset: 1 }}>
          <div className="d-flex flex-wrap">{renderDetails(rightCol)}</div>
        </Col>
      </Row>
      {/* Keeping this in incase a full row is needed */}
      {/* {fullCol.length > 0 && (
        <Row className="mb-3">
          <Col>
            <div className="d-flex flex-wrap">{renderDetails(fullCol)}</div>
          </Col>
        </Row>
      )} */}
    </Container>
  );
};

export default CourseOfferingDisplay;
